import { render } from "./patient-appointment-details.vue?vue&type=template&id=69296538"
import script from "./patient-appointment-details.vue?vue&type=script&lang=js"
export * from "./patient-appointment-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__